import { render, staticRenderFns } from "./ReferralProgramLeads.vue?vue&type=template&id=2a49668a&scoped=true&"
import script from "./ReferralProgramLeads.vue?vue&type=script&lang=js&"
export * from "./ReferralProgramLeads.vue?vue&type=script&lang=js&"
import style0 from "./ReferralProgramLeads.vue?vue&type=style&index=0&id=2a49668a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a49668a",
  null
  
)

export default component.exports